import { useState } from 'react';

import { AppEvents, useAppEventBus } from '@gasbi/shared/web/utils/appEventBus';

import { palette } from '@/utils/theme';

import Loader from '@components/ui/Loader';

const GlobalLoadingScreen = () => {
  const [active, setActive] = useState<boolean>(true);

  useAppEventBus(AppEvents.LoadingStateEvent, isLoading =>
    setActive(isLoading),
  );

  if (!active) {
    return null;
  }

  return (
    <Loader
      sx={{
        top: 0,
        left: 0,
        '.MuiCircularProgress-progress': {
          stroke: palette.primary[500],
        },
      }}
    />
  );
};

export default GlobalLoadingScreen;
